/* loaded by smart-asset */
export default require("./topology~tBrQFXdh.png")